import { debounce, get } from "lodash";
import { useEffect } from "react";

import {
  CurriculumGroupStatus,
  useGetGroupsLazyQuery,
} from "~/schemas/generated/graphql";

export const useGetAllGroupsForSelect = () => {
  const [getGroups, { data, loading, fetchMore }] = useGetGroupsLazyQuery({
    variables: {
      page: 0,
      count: 25,
      status: CurriculumGroupStatus.Active,
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    getGroups();
  }, []);

  const groups = [
    ...get(data, "EducationGetter.getListGroupCurriculum.items", []).map(
      ({ id, name }) => {
        return {
          value: id,
          label: `${name}`,
        };
      },
    ),
  ];

  const intersectionObserver = () => {
    if (groups.length < 25) {
      return;
    }
    const page = Math.ceil(groups.length / 25);
    fetchMore({
      variables: {
        page,
        count: 25,
      },
      updateQuery: ({ EducationGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { EducationGetter };
        }
        return {
          EducationGetter: {
            ...EducationGetter,
            getListGroupCurriculum: {
              ...EducationGetter.getListGroupCurriculum,
              items: [
                ...EducationGetter.getListGroupCurriculum.items,
                ...get(
                  fetchMoreResult,
                  "EducationGetter.getListGroupCurriculum.items",
                  [],
                ),
              ],
            },
          },
        };
      },
    });
  };

  const searchText = debounce((searchText: string) => {
    getGroups({
      variables: {
        page: 0,
        name: searchText || null,
      },
    });
  });

  return {
    groups,
    intersectionObserver,
    searchText,
    loading,
  };
};
